import { useEffect, useRef, useState } from 'react';

/* ── Scroll reveal: adds .visible when element enters viewport ── */
export function useReveal() {
  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
      { threshold: 0.08 }
    );
    document.querySelectorAll('.reveal,.rl,.rr').forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);
}

/* ── Count-up animation hook ── */
export function useCountUp(target, duration = 2000, trigger = true) {
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    if (!trigger || started.current) return;
    started.current = true;
    const steps    = 60;
    const interval = duration / steps;
    const step     = target / steps;
    let current    = 0;
    const timer    = setInterval(() => {
      current += step;
      if (current >= target) { current = target; clearInterval(timer); }
      setCount(Math.floor(current));
    }, interval);
    return () => clearInterval(timer);
  }, [trigger, target, duration]);

  return count;
}

/* ── IntersectionObserver single-element hook ── */
export function useInView(threshold = 0.15) {
  const ref       = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); io.disconnect(); } },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);

  return [ref, inView];
}
